// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";

import { getFirestore } from "firebase/firestore"; // ✅ Importa Firestore

const firebaseConfig = {
  apiKey: "AIzaSyCaG-RBfqj_vLLKVUySb9LU7IXj-3qt6-M",
  authDomain: "suppergames-col.firebaseapp.com",
  projectId: "suppergames-col",
  storageBucket: "suppergames-col.firebasestorage.app",
  messagingSenderId: "725202894184",
  appId: "1:725202894184:web:4dd00df2af55a1abc3eadd",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, googleProvider, signInWithPopup, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail, db };


